exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mask[data-v-d86e4e0a] {\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.body[data-v-d86e4e0a] {\n  width: 60vw;\n  min-width: 800px;\n  background: #f2f3fd;\n  padding: 12px 32px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d86e4e0a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/usr/src/app/src/assets/_include-media.scss","/usr/src/app/src/assets/palette.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/event/attendeeCreate.vue
// module id = 9Geh
// module chunks = 1